<template>
  <div class="edit-session-view">
    <div class="view-header">
      <h1 class="page-title">
        <span class="title-icon">✏️</span>
        Edit Session
      </h1>
      <p class="page-description">Make changes to session information and details</p>
    </div>
    
    <SessionEditForm :id="id" />
  </div>
</template>

<script>
import SessionEditForm from '../components/forms/SessionEditForm.vue'

export default {
  name: 'EditSession',
  components: {
    SessionEditForm
  },
  props: {
    id: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
/* Import the tier colors */
@import '../styles/tier-colors.css';

.edit-session-view {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
}

.view-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #f3f3f3;
  margin: 0 0 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.title-icon {
  font-size: 2rem;
  color: var(--tier-d-color, #00bfff);
}

.page-description {
  font-size: 1.125rem;
  color: #aaa;
  margin: 0;
  font-weight: 400;
}

/* Responsive design */
@media (max-width: 768px) {
  .edit-session-view {
    padding: 1rem;
  }
  
  .page-title {
    font-size: 2rem;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .title-icon {
    font-size: 1.5rem;
  }
  
  .page-description {
    font-size: 1rem;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .view-header {
    border-bottom-width: 2px;
  }
  
  .page-title {
    font-weight: 800;
  }
}
</style>